import React, { useContext } from 'react';
import { AddressSelectionContext } from '../../AddressSelectionProvider';
import { RadioButton, RadioButtonGroup } from '../../../button/RadioButton';

export const OrderTime: React.FC = () => {
  const { setIsPreorder, isPreorder } = useContext(AddressSelectionContext);

  return (
    <>
      <RadioButtonGroup aria-label="Tilauksen ajankohta">
        <RadioButton
          onClick={() => {
            setIsPreorder(false);
          }}
          selected={!isPreorder}
          aria-selected={!isPreorder}
        >
          Tilaan heti
        </RadioButton>
        <RadioButton
          onClick={() => {
            setIsPreorder(true);
          }}
          selected={isPreorder}
          aria-selected={isPreorder}
        >
          Teen ennakkotilauksen
        </RadioButton>
      </RadioButtonGroup>
    </>
  );
};
